import {Component} from 'react';
import PropTypes from 'prop-types';
import {Button} from '@emoney/kyber';
import './media-play-print.less';
import {fileTypeService, trackingEventsService, pdfBrandingService} from '_app/services';
import {Enums} from '_app/utils';
import MediaPreview from '_app/shared/components/MediaPreview';
import ShareControl from '_app/shared/features/ShareControl';

export default class MediaPlayPrint extends Component {
	static propTypes = {
		media: PropTypes.object.isRequired,
		token: PropTypes.string,
		advisorDisclaimer: PropTypes.string,
		versionDisclaimer: PropTypes.string,
		officeFooter: PropTypes.string,
		complianceID: PropTypes.string,
		showShare: PropTypes.bool.isRequired,
		userInfo: PropTypes.object,
		office: PropTypes.object
	}

	documentButtons() {
		var result = null;

		if (this.isThirdPartyContent()) {
			result = (
				<div
					role="toolbar"
					className="btn-toolbar"
					style={{
						marginTop:'5px'
					}}
				>
					<Button
						primary
						className="btn-xs primary-button"
						onClick={this.documentView}
					>
						View
					</Button>
				</div>
			);
		} else if (this.props.media.ExternalMediaID) {
			result = (
				<div
					role="toolbar"
					style={{
						marginTop:'5px'
					}}
					className="btn-toolbar"
				>
					<Button
						primary
						className="btn-xs primary-button"
						onClick={this.documentView}
					>
						View
					</Button>
					<Button
						className="btn-xs"
						onClick={this.documentDownload}
					>
						Download
					</Button>
				</div>
			);
		}
		return result;
	}

	documentDownload = () => {
		this.eventSendAndNavigate(
			Enums.getType('eventTypes').DOCUMENT_DOWNLOAD,
			this.downloadUrl()
		);
	}

	documentView = () => {
		this.eventSendAndNavigate(
			Enums.getType('eventTypes').DOCUMENT_VIEW,
			this.viewUrl()
		);
	}

	parseCountryInfo = (city, state, zip) => {
		const countryInfo = (!city && !state && !zip) ? '' :

			(city ? city : '') +
			(city && (state || zip) ? ' ' : '') +
			(state ? state : '') +
			(state && zip ? ' ' : '') +
			(zip ? zip : '');

		return countryInfo;
	}

	getFirmBrandingFullAddress = (address1, address2, citystatezip) => {
		const addressLine1 = address1 ? (address1 + '\\n') : '';
		const addressLine2 = address2 ? (address2 + '\\n') : '';
		const citystatezippure = citystatezip ? citystatezip : '';
		var fulladdress = addressLine1 + addressLine2 + citystatezippure;

		return fulladdress;
	}

	findFirmBrandingFullAddressInfo = (firstOffice) => {
		if (firstOffice) {
			const {city, state, zip, address, address2} = firstOffice;
			const firmBrandingCountryInfo = this.parseCountryInfo(city, state, zip);
			const firmBrandingAddressInfo = this.getFirmBrandingFullAddress(address, address2, firmBrandingCountryInfo);

			return firmBrandingAddressInfo;
		} else {
			return '';
		}
	}

	viewUrl() {
		const {userInfo, media, office} = this.props;
		const {Name, SourceContentUrl, ExternalMediaID} = media;
		let {companyName, fullAddressHtml, displayName, businessPhone, cellPhone, websiteUrl, email, pdfBrandingEnabled, logoUrl} = userInfo;
		const {firmName, isFirmBrandingEnabled, locations, website, phone} = office || {};

		if (isFirmBrandingEnabled) {
			const firstOfficeLocation = locations && locations.find(location => location.officeLocationNumber === 1);

			companyName = firmName;
			fullAddressHtml = this.findFirmBrandingFullAddressInfo(firstOfficeLocation);
			displayName = null;
			businessPhone = phone;
			cellPhone = firstOfficeLocation && firstOfficeLocation.phone;
			email = office && office.email;
			websiteUrl = website;
		}

		if (pdfBrandingEnabled) {
			return pdfBrandingService.getUrl({
				token: this.isThirdPartyContent() ? null : ExternalMediaID,
				url: this.isThirdPartyContent() ? SourceContentUrl : null,
				mediaName: Name,
				companyName,
				fullAddress: fullAddressHtml && fullAddressHtml.replace('<br/>', '\\n'),
				displayName,
				businessPhone,
				websiteUrl,
				cellPhone,
				email,
				logoUrl,
				isView: true,
				isFirmBranding: isFirmBrandingEnabled
			});
		} else {
			const viewUrl = this.isThirdPartyContent() ? SourceContentUrl : fileTypeService.storedFileUrl(ExternalMediaID);

			return decodeURIComponent(viewUrl);
		}
	}


	downloadUrl() {
		const {userInfo, media, office} = this.props;
		const {Name, SourceContentUrl, ExternalMediaID} = media;
		let {companyName, fullAddressHtml, displayName, businessPhone, cellPhone, websiteUrl, email, pdfBrandingEnabled, logoUrl} = userInfo;
		const {firmName, isFirmBrandingEnabled, locations, website, phone} = office || {};

		if (isFirmBrandingEnabled) {
			const firstOfficeLocation = locations && locations.find(location => location.officeLocationNumber === 1);

			companyName = firmName;
			fullAddressHtml = this.findFirmBrandingFullAddressInfo(firstOfficeLocation);
			displayName = null;
			businessPhone = phone;
			cellPhone = firstOfficeLocation && firstOfficeLocation.phone;
			email = office && office.email;
			websiteUrl = website;
		}

		if (pdfBrandingEnabled) {
			return pdfBrandingService.getUrl({
				token: this.isThirdPartyContent() ? null : ExternalMediaID,
				url: this.isThirdPartyContent() ? SourceContentUrl : null,
				mediaName: Name,
				companyName,
				fullAddress: fullAddressHtml && fullAddressHtml.replace('<br/>', '\\n'),
				displayName,
				businessPhone,
				websiteUrl,
				cellPhone,
				email,
				logoUrl,
				isView: false,
				isFirmBranding: isFirmBrandingEnabled
			});
		} else {
			const downloadUrl = this.isThirdPartyContent() ? SourceContentUrl : fileTypeService.storedFileDownloadUrl(ExternalMediaID);

			return decodeURIComponent(downloadUrl);
		}
	}

	eventSendAndNavigate(eventType, destinationUrl) {
		if (!this.props.token) {
			return;
		}

		trackingEventsService
			.add(this.props.token, eventType)
			.always(function() {
				(eventType === 201) ? window.open(destinationUrl,'_blank') : window.location.href = destinationUrl;
			});
	}

	isThirdPartyContent() {
		return !!this.props.media.SourceContentUrl;
	}

	printSection() {
		if (!this.isThirdPartyContent() && !this.props.media.ExternalMediaID) {
			return null;
		}
		const isAdminComplianceUser = this.props.userInfo.isAdminUser || this.props.userInfo.isComplianceUser;

		return (
			<div className="print-section" key="PRINT">
				<div className="print">
					<MediaPreview
						item={this.props.media}
						type="large"
						link={this.viewUrl()}
						target="_blank"
					/>
					{!this.props.showShare && !isAdminComplianceUser &&
						this.documentButtons()
					}
				</div>
				<div className="print-info">
					<span className="video-name">{this.props.media.Name}</span>
					<span className="video-desc">{this.props.media.Description}</span>
					{this.props.showShare &&
						<ShareControl
							media={this.props.media}
							download
							detail
							downloadUrl={this.downloadUrl()}
						/>
					}
				</div>
			</div>
		);
	}

	render() {
		var content = null;
		var printSection = this.printSection();

		if (printSection) {
			content = (
				<div>
					<div className="main-section">
						{printSection}
					</div>
				</div>
			);
		} else {
			content = (
				<div className="print-section">
					<div>Document Not Found</div>
				</div>
			);
		}

		return (
			<div className="media-view-container">
				{content}
			</div>
		);
	}
}